import { ICustomSlide } from './SlideShowTypes';
import Button from '../_Core/Button';
import StoreX from '../../redux/oldStore';

interface IProps {
  slides: ICustomSlide[];
  onChange: (slides: ICustomSlide[]) => void;
  onSave: () => void;
}

const INSERT_OPTIONS = [
  { value: 'title', label: 'After title slide' },
  { value: 'CategoryAwards', label: 'After category awards' },
  { value: 'CategoryAwardsByDivision', label: 'After category awards by division' },
  { value: 'SpecialAwards', label: 'After special awards' },
  { value: 'Sponsors', label: 'After sponsors' },
  { value: 'ThankYouJudges', label: 'After thank-you judges' },
  { value: 'ThankYouVolunteer', label: 'After thank-you volunteers' },
  { value: 'end', label: 'End of show' },
];

const CustomSlidesEditor = (props: IProps) => {
  const update = (index: number, patch: Partial<ICustomSlide>) => {
    props.onChange(props.slides.map((s, i) => (i === index ? { ...s, ...patch } : s)));
  };

  return (
    <div className="ss-editor">
      <div className="flex-between">
        <h4>Custom slides</h4>
        <div>
          <Button
            type="new"
            text="Add slide"
            onClick={() =>
              props.onChange([
                ...props.slides,
                { Id: StoreX.NewGuid(), Title: '', InsertAfter: 'end' },
              ])
            }
          />
          <Button type="save" text="Save custom slides" onClick={props.onSave} />
        </div>
      </div>
      <p className="ss-help">Mix your own title, message, or image slides into the generated awards deck.</p>
      {props.slides.map((s, i) => (
        <div key={s.Id || i} className="ss-editor-item">
          <div className="ss-editor-row">
            <div className="form-group">
              <label className="control-label">Title</label>
              <input className="form-control" value={s.Title || ''} onChange={(e) => update(i, { Title: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="control-label">Subtitle</label>
              <input className="form-control" value={s.SubTitle || ''} onChange={(e) => update(i, { SubTitle: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="control-label">Body</label>
              <textarea className="form-control" rows={2} value={s.Body || ''} onChange={(e) => update(i, { Body: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="control-label">Image URL</label>
              <input className="form-control" value={s.ImageUrl || ''} onChange={(e) => update(i, { ImageUrl: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="control-label">Insert after</label>
              <select className="form-control" value={s.InsertAfter || 'end'} onChange={(e) => update(i, { InsertAfter: e.target.value })}>
                {INSERT_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="control-label">&nbsp;</label>
              <div>
                <Button type="up" text="Up" disabled={i === 0} onClick={() => {
                  if (i === 0) return;
                  const next = [...props.slides];
                  [next[i - 1], next[i]] = [next[i], next[i - 1]];
                  props.onChange(next);
                }} />
                <Button type="down" text="Down" disabled={i === props.slides.length - 1} onClick={() => {
                  if (i >= props.slides.length - 1) return;
                  const next = [...props.slides];
                  [next[i + 1], next[i]] = [next[i], next[i + 1]];
                  props.onChange(next);
                }} />
                <Button type="remove" text="Remove" onClick={() => props.onChange(props.slides.filter((_, j) => j !== i))} />
              </div>
            </div>
          </div>
        </div>
      ))}
      {props.slides.length === 0 && <p className="ss-help">No custom slides yet.</p>}
    </div>
  );
};

export default CustomSlidesEditor;
